(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-tabs"] && !Shopify.designMode) return;
  try {
    

(function () {

  function initialize(scope) {
    var roots = [];

    if (
      scope.matches &&
      scope.matches('.kpt-feature-tabs')
    ) {
      roots.push(scope);
    }

    if (scope.querySelectorAll) {
      roots.push(
        ...scope.querySelectorAll('.kpt-feature-tabs')
      );
    }

    roots.forEach(function(root) {

      if (root.dataset.initialized === 'true') {
        return;
      }

      root.dataset.initialized = 'true';

      var items = [
        ...root.querySelectorAll('[data-feature-item]')
      ];

      var panels = [
        ...root.querySelectorAll('[data-feature-panel]')
      ];

      if (!items.length) return;

      var activeIndex = 0;
      var mediaIndex = 0;

      function render() {

        items.forEach(function(item, index) {

          var active = index === activeIndex;

          item.classList.toggle('is-active', active);

          var button = item.querySelector(
            '.kpt-feature-tabs__button'
          );

          var info = item.querySelector(
            '.kpt-feature-tabs__info'
          );

          if (button) {
            button.setAttribute(
              'aria-expanded',
              active ? 'true' : 'false'
            );
          }

          if (info) {
            info.hidden = !active;
          }
        });

        panels.forEach(function(panel, index) {
          var visible = index === mediaIndex;

          panel.classList.toggle(
            'is-active',
            visible
          );

          panel.setAttribute(
            'aria-hidden',
            visible ? 'false' : 'true'
          );
        });
      }

      function openFeature(index) {
        if (index < 0 || index >= items.length) {
          return;
        }

        activeIndex = index;
        mediaIndex = index;
        render();
      }

      root.kptOpenFeature = openFeature;

      items.forEach(function(item, index) {

        var button = item.querySelector(
          '.kpt-feature-tabs__button'
        );

        if (!button) return;

        button.addEventListener('click', function() {

          if (activeIndex === index) {
            // 再点一次：收起文字
            // 电脑端保留最后一张图片
            activeIndex = -1;
          } else {
            activeIndex = index;
            mediaIndex = index;
          }

          render();
        });
      });

      render();
    });
  }

  function start() {
    initialize(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }

  /* Shopify 编辑器兼容 */
  if (!window.kptFeatureTabsEventsBound) {

    window.kptFeatureTabsEventsBound = true;

    document.addEventListener(
      'shopify:section:load',
      function(event) {
        initialize(event.target);
      }
    );

    document.addEventListener(
      'shopify:block:select',
      function(event) {

        var item = event.target.closest(
          '[data-feature-item]'
        );

        if (!item) return;

        var root = item.closest('.kpt-feature-tabs');

        if (!root || !root.kptOpenFeature) {
          return;
        }

        var index = Number(
          item.dataset.featureItem
        );

        root.kptOpenFeature(index);
      }
    );
  }

})();


  } catch(e) { console.error(e); }
})();
})();
